export const handlePlayerCard = (element: HTMLDivElement) => {
  const nextItem = element?.nextElementSibling as HTMLElement;
  const nextItemImages = nextItem?.querySelectorAll('[data-src]') as NodeListOf<HTMLImageElement>;

  nextItemImages?.forEach((image) => {
    if (image instanceof HTMLImageElement) {
      image.setAttribute('src', `${image.dataset.src}?im=Resize,width=220` || '');
      image.setAttribute(
        'srcset',
        `${image.dataset.src}?im=Resize,width=220 1x, ${image.dataset.src}?im=Resize,width=440 2x` || ''
      );
    }
  });
};
